import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = {
	auth: true
}

export default {
	path: '/stationManage',
	name: 'stationManage',
	meta,
	redirect: {
		name: 'stationManage-index'
	},
	component: layoutHeaderAside,
	children: (pre => [
		{
			path: 'storeList',
			name: `${pre}list`,
			component: _import('stationManage/store/storeList'),
			meta: {
				...meta,
				title: '驿站管理'
			}
		},
		{
			path: 'dateOrder',
			name: `${pre}date`,
			component: _import('stationManage/order/dateOrder'),
			meta: {
				...meta,
				title: '订单列表'
			}
		},
		{
			path: 'feedback',
			name: `${pre}feedback`,
			component: _import('stationManage/order/feedbackList'),
			meta: {
				...meta,
				title: '反馈列表'
			}
		},
	])('stationManage-')
}